import { render } from "./MemberUseCoupon.vue?vue&type=template&id=cb3db586"
import script from "./MemberUseCoupon.vue?vue&type=script&lang=js"
export * from "./MemberUseCoupon.vue?vue&type=script&lang=js"
script.render = render

export default script